import script from "./LichessArenaView.vue?vue&type=script&setup=true&lang=js"
export * from "./LichessArenaView.vue?vue&type=script&setup=true&lang=js"

import "./LichessArenaView.vue?vue&type=style&index=0&id=ad0334ba&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad0334ba"]])

export default __exports__